import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDeleteAccount = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	width: 24,
	height: 24,
	viewBox: "0 0 50 50",
	enableBackground: "new 0 0 50 50",
	xmlSpace: "preserve",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M18.8,24.3c5.6,0,10.4-7.2,10.4-13C29.2,5.6,24.5,1,18.8,1S8.5,5.6,8.5,11.3C8.5,17.2,13.2,24.3,18.8,24.3z M18.8,3   c4.6,0,8.4,3.7,8.4,8.3c0,4.9-3.9,11-8.4,11s-8.4-6.2-8.4-11C10.5,6.7,14.2,3,18.8,3z",
			fill: "#2771bb",
			stroke: "#2771bb"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M37.8,23.8c-3.8,0-7.2,1.9-9.2,4.9c-2.2-1.3-4.7-1.9-7.3-1.9h-5.6C7.9,26.7,1.3,32.9,1,41v7c0,0.6,0.4,1,1,1h33.1   c0.6,0,1-0.4,1-1v-2.1c0.6,0.1,1.2,0.2,1.8,0.2c6.1,0,11.2-5,11.2-11.1S44,23.8,37.8,23.8z M34.1,47H3l0-6   c0.3-6.9,5.9-12.3,12.8-12.3h5.6c2.2,0,4.4,0.6,6.3,1.7c-0.6,1.4-1,2.9-1,4.5c0,4.8,3.1,8.9,7.4,10.5V47z M37.8,44.1   c-5,0-9.2-4.1-9.2-9.1s4.1-9.1,9.2-9.1c5,0,9.2,4.1,9.2,9.1S42.9,44.1,37.8,44.1z",
			fill: "#2771bb",
			stroke: "#2771bb"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M42,33.9h-8.3c-0.6,0-1,0.4-1,1s0.4,1,1,1H42c0.6,0,1-0.4,1-1S42.5,33.9,42,33.9z",
			stroke: "#2771bb",
			fill: "#2771bb"
		})
	] })]
});
const ForwardRef = forwardRef(SvgDeleteAccount);
export default ForwardRef;
